import { useCallback } from 'react';
import { useFetch } from '../benchmarks/hooks';
import AudienceABTestingService from './service';
import { normalizeDistributionsAndNetworks } from './components/Wizard/Steps/wizardUtils';

export const useFetchDistributionData = translate => {
    const fetchDistributionCallback = useCallback(async () => {
        const audienceAbTestingAPI = new AudienceABTestingService();
        const { value } = await audienceAbTestingAPI.getDistributions();
        const { networks } = value;
        const { allNetworks, internalDistributions, distributionNetworks } = normalizeDistributionsAndNetworks(
            networks,
            translate
        );
        return {
            data: { allNetworks, internalDistributions, distributionNetworks },
        };
    }, [translate]);

    return useFetch(fetchDistributionCallback, () => true);
};
